import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authService from '../slice/authService';
import ZoomSession from '../slice/ZoomSession';

const stripRefreshTokenFromPersist = createTransform(
    (inboundState) => inboundState,
    (outboundState) => {
        if (!outboundState?.auth) {
            return outboundState;
        }
        return {
            ...outboundState,
            auth: {
                ...outboundState.auth,
                refreshToken: null,
            },
        };
    }
);

const reducerlist = combineReducers({
    auth: authService,
    ZoomSession: ZoomSession
});
const persistConfig = {
    key: 'root',
    storage,
    transforms: [stripRefreshTokenFromPersist],
}
const persistedReducer = persistReducer(persistConfig, reducerlist)
export const store = configureStore({
    reducer: persistedReducer,
    devTools: true,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }),
})
export const persistor = persistStore(store)
export default store;
